import { render, staticRenderFns } from "./AddSacramentAttendance.vue?vue&type=template&id=23a0d78b&"
import script from "./AddSacramentAttendance.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddSacramentAttendance.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports